import { css } from '@emotion/react';

import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const topSearchContainer = css`
  width: 100%;
`;

export const topSearchWrapper = css`
  gap: 8px;
  ${flex('row', 'flex-start')};
  flex-wrap: wrap;
`;

export const thumbnailImageStyle = (hideMenu: boolean) => css`
  flex: 0 0 calc(32% - 2px);
  ${MQ.MediaSm} {
    flex: 0 0 calc(20% - 7px);
  }
  ${MQ.MediaMd} {
    flex: 0 0 calc(20% - 7px);
  }
  ${MQ.MediaLg} {
    ${hideMenu ? `flex: 0 0 calc(20% - 7px)` : `flex: 0 0 calc(33% - 5px)`};
  }
  ${MQ.MediaXl} {
    ${hideMenu ? 'flex: 0 0 calc(11% - 5px)' : ''};
  }
  &:hover {
    transform: scale3d(1.05, 1.05, 1) translate3d(0, 0, 0);
    transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;
